import script from "./locations.vue?vue&type=script&setup=true&lang=js"
export * from "./locations.vue?vue&type=script&setup=true&lang=js"

import "./locations.vue?vue&type=style&index=0&id=51410f70&lang=css&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-51410f70"]])

export default __exports__